// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1iwVW","rootSmall":"AddTileButton_rootSmall__1FD5z"};